import { render, staticRenderFns } from "./MensageriaModelsList.vue?vue&type=template&id=5ce81364&scoped=true"
import script from "./MensageriaModelsList.vue?vue&type=script&lang=js"
export * from "./MensageriaModelsList.vue?vue&type=script&lang=js"
import style0 from "./MensageriaModelsList.vue?vue&type=style&index=0&id=5ce81364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce81364",
  null
  
)

export default component.exports